module.exports = __webpack_public_path__ + "img/podcast-bg.ca51593.webp";